<template>
    <div id="slider-item">
        <div class="featured-post">
            <div class="post-content">
                <a class="post-cat" href="#">Health</a>
                <h2 class="post-title title-extra-large">
                    <a href="#">Netcix cuts out the chill with an integrated personal trainer on running</a>
                </h2>
                <span class="post-date">March 16, 2017</span>
            </div>
        </div>
        <a href="#tb1"><img src="/images/test-banner1.jpg"/></a>
    </div>
</template>

<script>
    export default {
        name: 'slider-item',
        props: ['data'],
        data() {
            return {
                image_url: '',
            }
        }
    }
</script>